@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.finn-ut-mer {
  margin-bottom: 2rem;

  &__heading {
    margin-bottom: 0.5rem;
  }

  &__text {
    margin-bottom: 2.5rem;

    @media (min-width: map.get($grid-breakpoints, md)) {
      margin-bottom: 4.375rem;
    }
  }

  &__button {
    text-decoration: none;
    margin-bottom: 0.5rem;

    @media (min-width: map.get($grid-breakpoints, md)) {
      margin-bottom: 2rem;
    }

    &:hover .finn-ut-mer__bubble--header,
    &:focus .finn-ut-mer__bubble--header {
      text-decoration: underline;
    }

    &:focus {
      .finn-ut-mer__bubble {
        @media (min-width: map.get($grid-breakpoints, md)) {
          background-image: url('../../utils/Icons/Bubbles/Finn-ut-mer/boble-with-border.svg');
        }
      }

      .finn-ut-mer__bubble--vector {
        transform: translateX(1rem);

        @media (max-width: map.get($grid-breakpoints, md)) {
          transform: translateX(0.5rem);
        }
      }
    }

    &:focus-visible {
      outline: none;
    }
  }

  &__bubble {
    margin: 1rem 0;
    display: flex;

    @media (min-width: map.get($grid-breakpoints, md)) {
      margin: 0;
      position: relative;
      width: 100%;
      height: 19.25rem;
      background-size: 100% 100%;
      background-image: url('../../utils/Icons/Bubbles/Finn-ut-mer/boble.svg');
      background-repeat: no-repeat;

      &:hover {
        background-image: url('../../utils/Icons/Bubbles/Finn-ut-mer/boble-with-border.svg');
      }
    }

    @media (min-width: map.get($grid-breakpoints, lg)) {
      height: 23.25rem;
    }

    &--text-section {
      display: block;
      position: relative;
      width: 54%;
      align-self: center;

      @media (min-width: map.get($grid-breakpoints, md)) {
        margin-left: 1rem;
      }

      @media (min-width: map.get($grid-breakpoints, lg)) {
        margin-left: 2rem;
        width: 42%;
      }
    }

    &--header {
      font-family: Avenir, Montserrat, Poppins, serif;
      font-size: 1rem;
      font-weight: 500;
      line-height: 2.25rem;
      letter-spacing: 0;
      text-align: left;
      color: white;
      margin: 0.5rem 0 1rem;

      @media (min-width: map.get($grid-breakpoints, md)) {
        font-size: 1.5rem;
        font-weight: 600;
      }
    }

    &--text {
      font-family: Avenir, Montserrat, Poppins, serif;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.125rem;
      letter-spacing: 0;
      text-align: left;
      color: #d5cfdc;

      @media (min-width: map.get($grid-breakpoints, md)) {
        line-height: 1.5rem;
        font-size: 1rem;
      }
    }

    &--logo {
      @media (min-width: map.get($grid-breakpoints, md)) {
        position: relative;
        width: 9.375rem;
        height: 9.375rem;
        background-image: url('../../utils/Icons/Bubbles/Finn-ut-mer/Ask\ Question.svg');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        align-self: center;
        margin-left: 2.125rem;
      }

      @media (min-width: map.get($grid-breakpoints, lg)) {
        width: 12.5625rem;
        height: 12.5625rem;
        margin-left: 3.125rem;
      }
    }

    &--vector {
      position: relative;
      background-image: url('../../utils/Icons/Bubbles/Finn-ut-mer/Vector.svg');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 2.5rem;
      width: 2.5rem;
      align-self: center;
      margin-left: auto;
      margin-right: 5%;
      transition: transform 0.4s;

      @media (min-width: map.get($grid-breakpoints, lg)) {
        margin-right: 10%;
      }
    }

    &:hover,
    &:focus {
      .finn-ut-mer__bubble--vector {
        transform: translateX(1rem);

        @media (max-width: map.get($grid-breakpoints, md)) {
          transform: translateX(0.5rem);
        }
      }
    }
  }
}

.hr {
  width: 100%;
}
